import {Avatar} from 'shells/avatar/avatar';
import {IconAvatar} from 'shells/avatar/icon-avatar';
import {colors} from 'shells/colors/colors';
import {CompanyRegularIcon} from 'shells/icon/svg/company-regular-icon';
import {ParentCompanyIcon} from 'shells/icon/svg/parent-company-icon';

import type {AccountPageFragment, NutFileInput} from 'nutshell-graphql-types';

import {usePreloadAvatar} from '../../hooks/use-preload-avatar';
import {PeepAvatarPicker} from '../../shared/header/avatar/peep-avatar-picker';

interface Props {
    account: AccountPageFragment;
    onUpdateAvatar: (avatarFile: NutFileInput | null) => Promise<any>;
}

export function AccountAvatar(props: Props) {
    const {displayedAvatarUrl, shouldShowUploadedAvatar} = usePreloadAvatar({
        avatarUrl: props.account.avatarUrl,
        hasUploadedAvatar: props.account.hasUploadedAvatar,
    });

    const childAccountCount = props.account.childAccounts.totalCount ?? 0;
    const hasChildAccounts = childAccountCount > 0 && NutClientConfig.hasAccountHierarchy;

    return (
        <PeepAvatarPicker
            peepType='account'
            hasUploadedAvatar={props.account.hasUploadedAvatar}
            canDeleteAvatar={props.account.canDeleteAvatar}
            onRemoveAvatar={() => {
                props.onUpdateAvatar(null);
            }}
            onUploadSuccess={(file) => {
                props.onUpdateAvatar(file);
            }}
        >
            {shouldShowUploadedAvatar ? (
                <Avatar
                    avatarUrl={displayedAvatarUrl}
                    size={72}
                    type='accounts'
                    displayBlock={true}
                />
            ) : (
                <IconAvatar
                    icon={hasChildAccounts ? ParentCompanyIcon : CompanyRegularIcon}
                    avatarSize={72}
                    iconSize={45}
                    backgroundColor={colors.plumBg}
                    iconColor={colors.company}
                />
            )}
        </PeepAvatarPicker>
    );
}
